const footerLinks = {
  explore: [
    { label: '行动方法论', path: '/category/action-methodology' },
    { label: '拖延心理学', path: '/category/procrastination-psychology' },
    { label: '习惯养成', path: '/category/habit-building' },
    { label: '成功案例', path: '/category/success-stories' },
    { label: '每日行动', path: '/category/daily-action' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '品牌故事', path: '/about#brand' },
    { label: '联系我们', path: '/about#contact' },
  ],
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50/80" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                就去干
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60 max-w-xs">
              打破拖延、立即行动的行动力觉醒平台。用科学的方法和真实的行动，帮你找回人生主动权。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2">
              {footerLinks.explore.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于</h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">每日一言</h4>
            <p className="text-sm text-background-50/60 italic leading-relaxed">
              「想，都是问题；干，才有答案。」<br />
              <span className="not-italic text-xs text-background-50/40 mt-1 block">—— 就去干行动哲学</span>
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} 就去干 行动力觉醒平台. All rights reserved.
          </p>
          <p className="text-xs text-background-50/40">
            用行动改变命运 —— 就去干
          </p>
        </div>
      </div>
    </footer>
  );
}